import React, { Component } from "react";
import BreadcrumbCustomer from "../breadcrumb";
import {  Form,Descriptions,TimePicker, Input, Button, Divider, Typography,Modal, Space,DatePicker,message, Tag, Empty} from 'antd';
import { searchImei } from '../../model/search/requests';
import { setDueDate,setPermanentUnlock } from '../../model/device_finance/requests';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import storage from '../../utils/storage';
import { configs } from '../../config/config';
import moment from "moment";
dayjs.extend(customParseFormat);

const { Paragraph } = Typography;


export const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 14,
    },
};

export const tailLayout = {
    wrapperCol: {
      offset: 8,
      span: 16,
    },
};



//const formatCurrent = moment(new Date()).add('year',0).format("YYYY-MM-DD");

// const disabledDate = (current) => {
//     return current < moment().startOf('day');
//   }
class LoanSingleUpdate extends Component {
    formRef = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            data:[],
            due_date:"",
            visiable : false,
            isButton:true,
            raw:{},
            installments:[]
        }
    };
    componentWillUnmount(){
        if (!storage.check(configs.cache.tokenKey)) {
            this.props.history.push("/")
        }
    }
    handleSubmit = ()=>{
        let imei =  this.formRef.current.getFieldValue('imei');
        if (typeof(imei) === "undefined"){
            message.error("you should input a imei")
            return false
        }
        searchImei({imei:imei}).then(res=>{
            if(res.data.code === 200){
                if(res.data.data.length > 0){
                    let data = res.data.data[0]
                    let list = []
                    if(data.installments != ""){
                        let install_list = data.installments.split(",");
                        for(let i =0;i<install_list.length;i++){
                            list.push(install_list[i])
                        }
                    }

                    // 处理 时间戳
                    if(data.next_pay != ""){
                        let tags = false
                        let d = moment(data.next_pay,'YYYY/M/D').unix()
                        let current = moment(new Date()).unix()
                        if(d > current){
                            tags = true
                        }
                        data["tags"] = tags
                    }

                    data["list"] = list.join("  ")
            
                    this.setState({
                        isButton:false,
                        data:data
                    })
                }
            }else{
                message.error(res.data.msg)
                if(res.data.code === 20001 || res.data.code === 20002){
                 this.props.history.push("/")
                }
            }
        }).catch(err=>{
            message.error(err)
        })
        //  trigger the device to cloud 
        // getDeviceFinance({id:imei}).then(res=>{
        //     if(res.data.code === 200){
        //         let data = res.data.data
        //          this.setState({
        //             raw:data.raw_data
        //          })
        //     }else{
        //         message.error(res.data.msg)
        //     }
        //  }).catch(err=>{
        //      message.error(err)
        //  })
        
    }

    showModal =()=>{
        this.setState({
            visiable:true
        })

    }

    handleModalOK = () => {
        this.setState({
            visiable:false
        })
       
        let due_date = this.state.due_date
        let imei = this.formRef.current.getFieldValue('imei')
        due_date = due_date.concat(" 23:59:59")
         let raw = this.state.raw
        setDueDate({imei:imei,due_date:due_date}).then(res=>{
            if(res.data.code === 200){
                    message.success("set due date "+due_date+" successful ")
            }
        }).catch(err=>{
            message.error(err)
        })
    }

    handleChange = (date,dateString) => {
        this.setState({
            due_date:dateString
        })

    }

    setPermanentUnlock = (e)=>{
        let imei = this.formRef.current.getFieldValue('imei')
        setPermanentUnlock().then(res=>{
            if(res.data.code === 200){
                message.success("set permanent  successful ")
            }
        }).catch(err=>{
            message.error(err)
        })

    }

    render() {
        const {visiable} = this.state
        const {data} = this.state;
        return (
            <>
                <BreadcrumbCustomer first='Signle' second='Search' />
                <Typography>
                        <Paragraph>
                        . Function in this page is only for accounts with Administrator role.
                        </Paragraph>
                        <Paragraph>
                        . Choose the IMEI first, then manually change its next due date.
                        </Paragraph>
                        <Paragraph>
                        . If you can not find the IMEI, please check the input string format first. There should be not any space character when you input.
                        </Paragraph>
                </Typography>
                <Divider />
                <Form
                    {...layout}
                    initialValues={{
                        remember: true,
                    }}

                    ref={this.formRef}
                    >
                    <Form.Item
                            name="imei"
                            label="Imei"
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            name="due_date"
                            hidden
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            wrapperCol={{
                                span: 12,
                                offset: 6,
                              }}
                        >
                            <Space >
                            <Button
                             type="primary" 
                             onClick = {this.handleSubmit}
                             style={{background: "#851dd6",color:"white" }}
                             >
                                Search
                            </Button>
                            <Button
                             type="primary" 
                             onClick = {this.showModal}
                             disabled={this.state.isButton}
                             style={{background: "#851dd6",color:"white" }}
                             >
                                Set Duedate
                            </Button>
                            {/* <Button
                             type="primary" 
                              disabled={this.state.isButton}
                              onClick={this.setPermanentUnlock}
                             >
                                 Permanent Unlock It
                            </Button> */}
                            </Space>
                        </Form.Item>    
                </Form>    
                <Modal
                    title="Set The Due Date"
                    visible={visiable}
                    onOk= {this.handleModalOK}
                    onCancel = {()=> {this.setState({visiable:false})}}
                    destroyOnClose={true}
                >
                     <DatePicker 
                        onChange={this.handleChange} 
                   //     disabledDate = {disabledDate}
                     />
                      <TimePicker defaultValue={dayjs('23:59:59', 'HH:mm:ss')} disabled />
                </Modal>

                <Descriptions >
                    <Descriptions.Item label='Imei'>{this.state.data.imei}</Descriptions.Item>
                    {/* <Descriptions.Item label='Next Pay DL'>
                    {data.next_pay} 
                    <Space />
                    <Tag color={data.tags == true ? "green" : "red"}>
                            {data.tags== true ? "Normal" :"Overdue"}
                    </Tag>
                     </Descriptions.Item> */}
                    <Descriptions.Item label='Activation Date'>{this.state.data.action_date}</Descriptions.Item>
                    <Descriptions.Item label='CrossCheckingID1'>{this.state.data.cross_checking_id}</Descriptions.Item>
                    {/* <Descriptions.Item label='CrossCheckingID2'>{this.state.data.operator_user_id}</Descriptions.Item>
                    <Descriptions.Item label='LoanPeriod'>{this.state.data.loan_period}</Descriptions.Item>
                    <Descriptions.Item label='InstallMent'>{data.list}</Descriptions.Item> */}
                </Descriptions>

            </>
        );
    }
}

export default LoanSingleUpdate;